import React, { useContext, useEffect, useRef, useState } from 'react';
import MenuHeader from './../MenuHeader';
import DraggableItem from './DraggableItem';
import { ProductContext } from '../../../../store';
import DetailSkeleton from '../../../Skeleton/DetailSkeleton';

const PromoTiles = () => {

	const {
				promoTiles,
				promoTileLoader
			}	= useContext(ProductContext),
			divRef	= useRef(null),
			[height, setHeight] = useState("100vh")
		
		useEffect(() => {
			const calculateHeight = () => {
				if (divRef.current) {
					const topPosition = divRef.current.getBoundingClientRect().top
					const newHeight = `calc(100vh - ${topPosition}px)`
					setHeight(newHeight)
				}
			}
			// Calculate height initially
			calculateHeight()
	
			// Recalculate height on window resize
			window.addEventListener("resize", calculateHeight)
			return () => {
				window.removeEventListener("resize", calculateHeight)
			}
		}, [divRef])

	return (
		<React.Fragment>
			<MenuHeader title={"Promo Tiles"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{height: height, position: "relative"}}>
				<div className='menuContentWrapper'>
					<div style={{width: "100%", height: "100%", position: "relative", display: "flex", padding: "16px", flexDirection: "column", gap: "8px", boxSizing: "border-box"}}>
						{promoTileLoader ?
							<DetailSkeleton />
						:
							<>
								{promoTiles.length > 0 ?
									<>
										{promoTiles.map((promoTile, promoTileIndex) => {
											return (
												<DraggableItem key={promoTileIndex} id={{...promoTile, promoTileId: promoTile.id}}>
													<div product-id={"promoTile_" + promoTile.id} key={promoTileIndex} className='promoTileOuterContainer' style={{ width: "100%", height: "100%" }}>
														<div id={promoTile.id} className='promoTileInnerContainer'>
															<div className='promoTileContainer' style={{height: "200px"}}>
																<div className="promoTileImageContainer">
																	<img src={promoTile.image} alt={promoTile.title} className="promoTileImage" />
																	<div className="promoTileTitleContainer">{promoTile.title}</div>
																	<div className='promoTileSizeWrapper'>{promoTile.bannerSize}</div>
																</div>
															</div>
														</div>
													</div>
												</DraggableItem>
											)
										})}
									</>
								:
									<div className="emptyListMessageContainer">
										<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
											<g id="surface1">
												<path style={{stroke:"none",fillRule:"nonzero",fill:"rgb(0%,0%,0%)",fillOpacity:1}} d="M 17.679688 2.011719 C 15.550781 0.289062 12.757812 -0.378906 10.078125 0.199219 C 6.585938 0.953125 3.875 3.707031 3.175781 7.207031 C 2.53125 10.34375 3.609375 13.582031 6.003906 15.707031 L 6.003906 15.75 C 6.007812 16.925781 6.5625 18.03125 7.503906 18.734375 L 7.503906 20.25 C 7.503906 21.492188 8.511719 22.5 9.753906 22.5 L 10.285156 22.5 C 10.410156 23.355469 11.140625 23.992188 12.003906 24 C 12.867188 23.992188 13.597656 23.355469 13.722656 22.5 L 14.253906 22.5 C 15.496094 22.5 16.503906 21.492188 16.503906 20.25 L 16.503906 18.734375 C 17.445312 18.03125 18.003906 16.925781 18.003906 15.75 L 18.003906 15.707031 C 19.917969 14 21.007812 11.558594 21.003906 9 C 21.011719 6.285156 19.789062 3.71875 17.679688 2.011719 Z M 15.003906 19.5 L 15.003906 20.25 C 15.003906 20.664062 14.667969 21 14.253906 21 L 9.753906 21 C 9.339844 21 9.003906 20.664062 9.003906 20.25 L 9.003906 19.5 Z M 16.777344 14.785156 C 16.605469 14.925781 16.503906 15.140625 16.503906 15.363281 L 16.503906 15.75 C 16.503906 16.992188 15.496094 18 14.253906 18 L 9.753906 18 C 8.511719 18 7.503906 16.992188 7.503906 15.75 L 7.503906 15.363281 C 7.503906 15.140625 7.402344 14.925781 7.230469 14.785156 C 5.085938 13.023438 4.09375 10.21875 4.652344 7.496094 C 5.234375 4.585938 7.484375 2.300781 10.386719 1.671875 C 10.910156 1.558594 11.449219 1.5 11.988281 1.496094 C 13.714844 1.492188 15.390625 2.085938 16.734375 3.171875 C 18.492188 4.59375 19.511719 6.738281 19.503906 9 C 19.507812 11.238281 18.507812 13.359375 16.777344 14.785156 Z M 12.753906 5.246094 C 12.753906 5.660156 12.417969 5.996094 12.003906 5.996094 C 10.347656 5.996094 9.003906 7.339844 9.003906 9 C 9.003906 9.414062 8.667969 9.75 8.253906 9.75 C 7.839844 9.75 7.503906 9.414062 7.503906 9 C 7.503906 6.511719 9.519531 4.496094 12.003906 4.496094 C 12.417969 4.496094 12.753906 4.832031 12.753906 5.246094 Z M 12.753906 5.246094 "/>
											</g>
										</svg>
										<div>Hey There!</div>
										<div>The list is empty for now, but you can quickly add promo tiles in merchandising dashboard.</div>
										<div>Happy merchandising!</div>
									</div>
								}
							</>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default PromoTiles;